export async function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export async function sleepUntil(until: Date): Promise<void> {
  const ms = until.getTime() - Date.now();
  if (ms > 3) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  } else {
    return;
  }
}

export async function withTimeout<T>(fn: () => Promise<T>, timeoutMs?: number): Promise<T> {
  if (!timeoutMs) return fn();
  const ac = new AbortController();
  const t = setTimeout(() => ac.abort(), timeoutMs);
  try {
    return await Promise.race<T>([
      fn(),
      new Promise<T>((_, rej) => ac.signal.addEventListener('abort', () => rej(new Error('Request timeout')))),
    ]);
  } finally {
    clearTimeout(t);
  }
}
